// extracted by mini-css-extract-plugin
export default {"deductions-report-header":"LoanMovementReport_deductions-report-header__Ej3Ke"};